import React from 'react';
import {useGet} from "../../hooks/useGet";
import OverviewImageButtonPanel from "../../components/OverviewImageButtonPanel";
import DateButton from "../../components/DateButton";
import {createSubtitle} from "../../utils/itineraryUtils";
import {formatDMYtoYMD} from "../../utils/dateTimeUtils";
import FullScreenLoader from '../../components/FullScreenLoader';

function SparkOverview(props) {

    const {isLoading, error, data} = useGet("itinerary/schedules");

    if(isLoading) {
        return <FullScreenLoader />
    }

    if(error) {
        return <div>
            There has been an error: {error}
        </div>
    }

    return (
        <div>
            <OverviewImageButtonPanel>
                {
                    data.map((day, index) =>
                        <div key={day.id} className="cell">
                            <DateButton link={"/itinerary/spark"}
                                        linkId={formatDMYtoYMD(day.date)}
                                        scheduleId={day.id}
                                        date={day.date}
                                        disabled={false}
                                        index={index}
                                        title={day.title.defaultValue}
                                        subtitle={createSubtitle(day)}
                            />
                        </div>
                    )}
            </OverviewImageButtonPanel>
        </div>
    );
}

export default SparkOverview;